import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
// import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { holidayTypeDetailInitialsForAdd, holidayTypeDetailnitialsForUpdate } from './interfaces/holidayTypeDetailClass';
import { addHolidayTypeDetailAsync, updateHolidayTypeDetailAsync, resetSelectedRecordObjectInState } from './holidayTypeDetailSlice';
import { dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';
import fetchAPI from '../../../common/fetchAPI';
import { useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import moment from 'moment';

const HolidayTypeDetailForm = (props: any) => {

    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const location = useLocation();
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(holidayTypeDetailInitialsForAdd);
    const { selectedRecord, isLoading, MasterAccountHolidayTypeId } = useAppSelector((state) => state.holidayTypeDetail);
    const { CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay } = useAppSelector((state) => state.globalState);
    const dispatch = useAppDispatch();
    const { obj } = location.state || {};
    const storedObjectData = localStorage.getItem('objholidaytypeId');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    let AccountHolidayTypeId = '00000000-0000-0000-0000-000000000000';
    if (MasterAccountHolidayTypeId && MasterAccountHolidayTypeId !== '') {
        AccountHolidayTypeId = MasterAccountHolidayTypeId;
    } else if(objectData && objectData.AccountHolidayTypeId){
        AccountHolidayTypeId = objectData.AccountHolidayTypeId;  
    }

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(holidayTypeDetailnitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.HolidayDate = dateFormatByAccountCulture(stateItem.HolidayDate, cultureInfoName.toString());
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(holidayTypeDetailInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
    }, [selectedRecord])

    const handleDateChange = (date: any) => {
        const selectedDate = moment(date).format(cultureInfoName.toString())
        setCurrentFieldsData({ ...currentFieldsData, 'HolidayDate': date });
    }

    const handleSubmit = (values: any) => {
         const payload = {
        ...values,
        HolidayDate: moment(values.HolidayDate).format('YYYY-MM-DD')
    };
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateHolidayTypeDetailAsync(payload))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Holiday Update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {          
            dispatch(addHolidayTypeDetailAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Holiday Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }

    return (
        <>
            <Formik
                initialValues={{
                    ...currentFieldsData,
                    AccountHolidayTypeId: AccountHolidayTypeId,
                }}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    HolidayName: yup
                        .string()
                        .label('HolidayName')
                        .trim()
                        .required(getValueFromResource('Holiday name is required',dispatch,t))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? getValueFromResource('Update', dispatch, t) : getValueFromResource('Add',dispatch, t)} {getValueFromResource('Holiday',dispatch,t)} </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                        <div className="col-md-12 mb-2">
                                                                <label className="form-label fs-7 fw-normal">
                                                                    {/* {t('Holiday Date')} */}
                                                                    {getValueFromResource('Holiday Date',dispatch, t)}
                                                                    </label>
                                                                <div className="wrapper">
                                                                <DatePicker
                                                                 selected={values.HolidayDate}
                                                                    onChange={handleDateChange}
                                                                    calendarStartDay={calendarStartDay}
                                                                    // dateFormat="dd/MM/yyyy"
                                                                    dateFormat={CurrentCultureDateFormat.toString()}
                                                                    className="form-control w-452px ps-4 fs-7 fw-normal"
                                                                />
                                                                <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                                </div>
                                                                </div>
                                                                <div className="col-md-12 mb-2">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {/* {t('Holiday Name')} */}
                                                                    {getValueFromResource('Holiday Name',dispatch, t)}
                                                                    </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mt-2" id='HolidayName' value={values.HolidayName} name='HolidayName'
                                                                    onChange={handleChange('HolidayName')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('HolidayName', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.HolidayName && errors.HolidayName &&
                                                                    <p className='errorMsg'>{errors.HolidayName as string}</p>
                                                                }
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {/* {t('Cancel')} */}
                                                            {getValueFromResource('Cancel',dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm " onClick={() => handleSubmit()} disabled={!isValid}>
                                                            {/* {t('Save')} */}
                                                            {getValueFromResource('Save',dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )


}
export default HolidayTypeDetailForm